export function eur(n: number): string {
  return (n || 0).toLocaleString('es-ES') + ' €'
}

export function todayStr(): string {
  return new Date().toISOString().slice(0, 10)
}

export function uid(): string {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 6)
}

export function daysUntil(dateStr: string): number {
  if (!dateStr) return 999
  const target = new Date(dateStr)
  const today = new Date(todayStr())
  return Math.round((target.getTime() - today.getTime()) / 86400000)
}
